import React from 'react'

import RecipesOverview from '../../../react4xp/components/RecipesOverview'

function RecipesOverviewPart({title, image, endpoint, types, startValues, strings}) {
    return (
        <RecipesOverview
            title={title}
            image={image}
            endpoint={endpoint}
            types={types}
            startValues={startValues}
            strings={strings}
        />
    )
}

export default (props) => <RecipesOverviewPart {...props} />
